import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminClients from "./pages/admin/AdminClients";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminShipments from "./pages/admin/AdminShipments";
import AdminInvoices from "./pages/admin/AdminInvoices";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminPortalUsers from "./pages/admin/AdminPortalUsers";
import PortalLogin from "./pages/portal/PortalLogin";
import PortalRegister from "./pages/portal/PortalRegister";
import PortalLayout from "./pages/portal/PortalLayout";
import PortalDashboard from "./pages/portal/PortalDashboard";
import PortalQuotes from "./pages/portal/PortalQuotes";
import PortalNewQuote from "./pages/portal/PortalNewQuote";
import PortalOrders from "./pages/portal/PortalOrders";
import PortalShipments from "./pages/portal/PortalShipments";
import PortalInvoices from "./pages/portal/PortalInvoices";
import PortalCatalog from "./pages/portal/PortalCatalog";
import PortalProfile from "./pages/portal/PortalProfile";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPage />} />

          {/* Client Portal */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/register" element={<PortalRegister />} />
          <Route path="/portal" element={<PortalLayout />}>
            <Route index element={<PortalDashboard />} />
            <Route path="quotes" element={<PortalQuotes />} />
            <Route path="new-quote" element={<PortalNewQuote />} />
            <Route path="orders" element={<PortalOrders />} />
            <Route path="shipments" element={<PortalShipments />} />
            <Route path="invoices" element={<PortalInvoices />} />
            <Route path="catalog" element={<PortalCatalog />} />
            <Route path="profile" element={<PortalProfile />} />
          </Route>

          {/* Admin back-office */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="quotes" element={<AdminQuotes />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="shipments" element={<AdminShipments />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="portal-users" element={<AdminPortalUsers />} />
            <Route path="users" element={<AdminUsers />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
